import React  from 'react';
import { BuyBilet } from '../../../components/common/ButtonBuyBilet';
import { HeadLine } from '../../../components/common/Headline';
import {JsonOneSectionState} from "../../../DataJsons/OneSectionsLLC"


export const OneSectionPage = (props) => {
    const UntilTheEndLoto = (props) => {
        return  <div className="time_items">
                    <div className="text_end_lotorei">До окончания лотереи</div>
                    <div className="times">00 : 12 : 08</div>
                </div>
    }

    const Bilet = (props) => {
        return(
            <div className="loto_bilets">
                <div className="bilet">
                    <div className="bilet_content_info">
                        <div className="text_BTC">
                            <p> Розыгрышь BTC</p>
                            <svg width="20" height="2" viewBox="0 0 20 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <line y1="1" x2="20" y2="1" stroke="#212129" stroke-width="2"/>
                            </svg>
                        </div>
                        <div className="block_end_lot">
                            <div className="i_timer">
                                <img src="img/Timer.png" alt=""/>
                            </div>
                            <UntilTheEndLoto />
                        </div>
                        <div className="count_buy_bilet">
                            <div><img src="img/miniBilet.png" alt=""/></div>
                            <div>
                                <p>Купленных билетов: <b>563</b> </p>
                                <p>Осталось билетов: <b>92</b> </p>
                            </div>
                        </div>
                        <BuyBilet img="/img/mini_bilet_bleck.png"/>
                    </div>
                    <div className="btc_big_img">
                        <img src={props.btc_img} alt=""/>
                    </div>
                </div>
            </div>
        )
    }
    
    const ListLinkCompani = (props) => {
        return(
            <div className="block_link_site">
                <div className="logo">
                    <img src={props.img} alt="none"/>
                    <h3>{props.head}</h3>
                </div>
                <div className="lines">
                    <svg width="1" height="31" viewBox="0 0 1 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <line x1="0.5" y1="31" x2="0.499999" y2="2.18557e-08" stroke="#D6D6D6"/>
                    </svg>
                </div>
                <div className="text_btc_usdt">
                    <h3>BTC/USDT</h3>
                    <p>3.278085</p>
                </div>
            </div>
        )
    }

    return(
        <>
            <HeadLine headline="Текущая лотерея" />
            <div className="container">
                <div className="loto_card">
                    <span className="info_bilet">
                        <div className="vertical_text">
                            <div className="current_loto"> Лотерея #137</div>
                            <div className="current_loto_line">
                                <svg width="1" height="20" viewBox="0 0 1 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <line x1="0.5" y1="20" x2="0.5" stroke="#212129"/>
                                </svg>
                            </div>
                        </div>
                        <div className="lotoAvatar">
                            <div className="logo">
                                <h3>lotto</h3>
                                <h4>36</h4>
                            </div>
                        </div>
                        <div className="loto_time">
                            <svg width="30" height="35" viewBox="0 0 30 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M26.2244 10.8597L27.5993 9.49708C28.1336 8.96759 28.1336 8.10905 27.5993 7.57982C27.065 7.05032 26.1989 7.05032 25.6646 7.57982L24.2897 8.9424C21.9828 7.03759 19.1796 5.88686 16.1894 5.61747V2.88886H17.5119C18.2675 2.88886 18.8799 2.28168 18.8799 1.53291C18.8799 0.784134 18.2675 0.177216 17.5119 0.177216H12.1305C11.3749 0.177216 10.7625 0.784134 10.7625 1.53291C10.7625 2.28168 11.3749 2.88886 12.1305 2.88886H13.453V5.61747C5.96786 6.292 0 12.5235 0 20.2426C0 28.3603 6.62873 34.9304 14.8213 34.9304C23.0126 34.9304 29.6424 28.3614 29.6424 20.2426C29.6424 16.7751 28.4373 13.4912 26.2244 10.8597ZM14.8211 32.2187C8.15755 32.2187 2.73604 26.8464 2.73604 20.2426C2.73604 13.6392 8.15755 8.26681 14.8211 8.26681C21.4848 8.26681 26.9061 13.6392 26.9061 20.2426C26.9061 26.8464 21.4848 32.2187 14.8211 32.2187ZM21.1614 13.9598C21.6957 14.4892 21.6957 15.3478 21.1614 15.877L15.7886 21.2014C15.2542 21.7309 14.3879 21.7309 13.8538 21.2014C13.3195 20.6719 13.3195 19.8134 13.8538 19.2841L19.2264 13.9598C19.7607 13.4303 20.6271 13.4303 21.1614 13.9598Z" fill="#EC9F3C"/>
                            </svg>
                           <UntilTheEndLoto />
                            <div className="jeckpot">
                                <div className="loto_time">
                                    <img src="img/bingo1.png" alt=""/>
                                </div>
                                <div className="time_items">
                                    <div className="text_jecpot">джекпот</div>
                                    <div className="text_procent">5/36</div>
                                </div>
                                <div className="loto_time">
                                    <img src="img/Kuboc.png" alt=""/>
                                </div>
                                <div className="time_items">
                                    <div className="text_price">233 900 RUB</div>
                                    <div className="text_procent">10187.12$</div>
                                </div>
                            </div>
                        </div>
                    </span>
                    <span  className="r_img_bilet">
                        <img src="img/Bilet.png" alt=""/>
                    </span>
                </div>             
                <div className="flex_bilet">
                    <Bilet btc_img="img/btc_0.5.png" />
                    <Bilet btc_img="img/btc_10.png" />
                </div>
                <HeadLine headline="BTC на криптобиржах" />
                <div className="list_link_site">
                    {JsonOneSectionState.map( (p) => <ListLinkCompani key={p.id} img={p.img} head={p.head} />)}
                </div>
            </div>
        </>
    )
}